import { createSlice } from "@reduxjs/toolkit";
import IsEmptyArray from "../../utils/CheckArrayISEmpty";
import siteConfig from "../../common/lang/locale/en-US";

const initialState = {
	RoleCardDetails: [],
	commonInputs: {
		DealreviewID: null,
		ProjectId: null,
		ESTStartdate: null,
		ActualStartDate: null,
		ClientManaged: 'N',
		ActualEndDate: null,
		ESTEndDate: null,
		ESTClosedDate: null,
		CompanyName: null,
		ProjectName: null,
		Duration: null,
		PeekHeadcount: null,
		OnShore: null,
		OffShore: null,
		MSACompleted: "Yes",
		LifeCycle: [],
		PricingType: null,
		ServiceCategories: [],
		Technology: [],
		FeeExpenses: null,
		RiskAndAssumptions: null,
		Notes: null,
		DealOwner: null,

    DrStatus: null,
    CreatedBy: null,
    CreatedAt: null,
    LastUpdateBy: null,
    UpdatedAt: null,
    ParentDealReviewId: null,
    DrEffectiveTs: null,
    DrEndTs: null,
    SolutionsArchOverview: null,
    CapabilitiesLeadOverview: null,
    LegalOverview: null,
    StaffingOverview: null,

    TotalFixedPrice: null,
    TotalDiscount: null,
    TotalClCost: null,
    TotalPlCost: null,

    WavicleDiscount: null,
    DiscountInvestment: "%", // this for idendify wavicle discount is percentage or amount
	isPracticeLeadUtlization: "%",  // this for idendify practice lead is percentage or amount
	isCompetencyLeadUtilization:  "%", // this for idendify competency lead is percentage or amount
	isTravelExpenses: "%", // this for idendify travel expenses is percentage or amount
	isMiscExpenses: "%", // this for idendify misc expenses is percentage or amount
    CurrentMargin: null,
    ExpectedMargin: null,
    ExpensePercentage: null,
    MonthlyPayment: null,
    PLUtilization: null,
    CLUtilization: null,
    InABoxEM: null,
    InABoxDL: null,
    RevBefDeductions: null,
    RevAftDeductions: null,
    FinalGrossMargin: null,
    TotalWavicleCost: null,
    TotalClientPrice: null,
    TotalActRevenue: null,
    TotalRevenueAfterDeductions: null,
    TotalFixedPriceRevenue: null,
    TotalHoursProposed: null,
	MarginPercentage:null,

    Expenes: null,
    Airfare: null,
    Hotels: null,
    GroundTransport: null,
    Meals: null,
    Others: null,
    TotalTravelExpenses: null,

    DealRevenueAndGMBeforeDeductionsPercentage: null,
    DealRevenueAndGMAfterDeductionsPercentage: null,
    FinalGrossMarginPercentage: null,
    StaffingRatiosAndMarginOnshorePercentage: null,
    StaffingRatiosAndMarginOffshorePercentage: null,
    EM2InABoxUtilizationPercentage: null,
    DL2InABoxUtilizationPercentage: null,

    //deva create this state
    otherExpenses: null,
	TravelPercentage : null,
	Miscellaneous : null,

	RateCardId : null
  },
  isModalOpen: { IsOpen: false, ClickedIndex: 0 },
  isSavedDataIntoDB: false,
  isRequiredColumnFilled: true,
  Deals: {},
  FilterScreenData: [],
  NewDRSrceenData: [],
  SaveButtonLoading: false,
  ShowSnackbar: { isopen: false, message: "", type: "" },
  snackBar: { isopen: false, message: "", type: "" },
};

const Deals = createSlice({
	name: "Deals",
	initialState,
	reducers: {
		ChangeIsRequiredColumnFilledState: (state, action) => {
			return {
				...state,
				isRequiredColumnFilled: action.payload,
			};
		},
		commonInputOnChange: (state, action) => {
			const { name, value } = action.payload;
			state.commonInputs[name] = value;
		},
		OnChangeNewDRSrceenData: (state, action) => {
			const { name, value } = action.payload;
			state.NewDRSrceenData[0][name] = value;
		},
		addRoleCard: (state, action) => {
			state.RoleCardDetails.push({
				SheetID: action.payload === 'dr_insert' ? 0 : null,
				SWORoleName: null,
				RoleId: null,
				Role: null,
				Band: null,
				Location: null,
				Resources: null,
				ActualRate: null,
				FixedPriceRevenue: null,
				ProjectUtilization: null,
				CostUtilization: null,
				StartDate: state.commonInputs.ESTStartdate,
				EndDate: state.commonInputs.ESTEndDate,
				ProposedHours: null,
				Hours: null,
				HourlyCost: null,
				StandardRate: null,
				WavicleCost: null,
				ClientStandardPrice: null,
				ActualRevenue: null,
				RevenueAfterDeduction: null,
				PLCost: null,
				CLCost: null,
				WavicleDiscountCost: null,
				MarginPercentage:null,

				ClientManaged: "No",
				BackgroundCheck: null,
				RequiredSkills: [],
				RoleRequirements: null,
				ResourceType: null,
				LaptopNeeded: "No",
				InterviewPanel: [],
				HaveClientInterview: "No",
				ClientInterviewInfo: null,
				...(action.payload === 'dr_insert' ? {
					isNewlyAdded: true
				}: {})
			});
		},
		updateRoleCard: (state, action) => {
			const { roleCard } = action.payload;
			state.RoleCardDetails = roleCard;
		},
		deleteRoleCard: (state, action) => {
			const { clickedIndex } = action.payload;
			const RoleDetailsLength = state.RoleCardDetails.length === 1;
			if (RoleDetailsLength) {
				state.RoleCardDetails = [];
			} else {
				state.RoleCardDetails = state.RoleCardDetails.filter(
				(role, index) => index !== clickedIndex
				);
			}
			state.isModalOpen = { IsOpen: false, ClickedIndex: 0 };
    	},
    openModal: (state, action) => {
      state.isModalOpen = { IsOpen: true, ClickedIndex: action.payload };
    },
    closeModal: (state) => {
      state.isModalOpen = { IsOpen: false, ClickedIndex: 0 };
    },
    updateStaffingIntakeProperty: (state, action) => {
      const { sheetId, property, value } = action.payload;
      const updatedRoleCardDetails = state.RoleCardDetails.map((RoleCard) => {
        if (RoleCard.SheetID === sheetId) {
          return { ...RoleCard, [property]: value };
        }
        return RoleCard;
      });

      return {
        ...state,
        RoleCardDetails: updatedRoleCardDetails,
      };
    },
    updateRoleCardProperty: (state, action) => {
      const { index, property, value } = action.payload;
	  if(state.RoleCardDetails && state.RoleCardDetails[index]) {
		state.RoleCardDetails[index][property] = value;
	  }
    },
    updateRoleCardPropertyWithSheetId: (state, action) => {
      const { StaffSheetId, property, value } = action.payload;
	  if(state.RoleCardDetails) {
		const index = state.RoleCardDetails.findIndex((item) => item.SheetID === StaffSheetId);
		state.RoleCardDetails[index][property] = value;
	  }
    },
    setSavedData: (state, action) => {
      state.isSavedDataIntoDB = true;
    },
    setChangeData: (state, action) => {
      state.isSavedDataIntoDB = false;
    },
    AddDeals: (state, action) => {
      state.Deals = action.payload;
    },
    addLifeCycle: (state, action) => {
      return {
        ...state,
        commonInputs: {
          ...state.commonInputs,
          LifeCycle: state.commonInputs.LifeCycle.concat(action.payload),
        },
      };
    },
    setSaveButtonLoadingTrue: (state, action) => {
      state.SaveButtonLoading = true;
    },
    setSaveButtonLoadingFalse: (state, action) => {
      state.SaveButtonLoading = false;
    },
    ShowSnackbar: (state, action) => {
      state.ShowSnackbar = { isopen: true, message: "", type: "" };
    },
    HideSnackbar: (state, action) => {
      state.ShowSnackbar = { isopen: false, message: "", type: "" };
    },
    visibleSnackBar: (state, action) => {
      state.snackBar = {
        isopen: true,
        message: action.payload.message,
        type: action.payload.type,
      };
    },
    setCommonInputs: (state, action) => {
      if (action.payload) {
        const AP = action.payload;
        return {
          ...state,
          commonInputs: {
            ...state.commonInputs,
            DealreviewID: AP.deal_review_id,
            ProjectId: AP.project_id_var,
            ESTStartdate: AP.est_start_date
              ? new Date(AP.est_start_date).toISOString().split("T")[0]
              : null,
            ESTEndDate: AP.est_end_date
              ? new Date(AP.est_end_date).toISOString().split("T")[0]
              : null,
            ESTClosedDate: AP.est_close_date
              ? new Date(AP.est_close_date).toISOString().split("T")[0]
              : null,
            CompanyName: AP.company_name,
            ProjectName: AP.project_name,
            Duration: AP.duration_in_weeks,
            PeekHeadcount: AP.peak_headcount,
            OnShore: AP.onsite_staff_percent,
            OffShore: AP.offshore_staff_percent,
            MSACompleted: AP.msa_complete,
            LifeCycle: AP.life_cycle,
            PricingType: AP.pricing_type,
            ServiceCategories: AP.services_included,
            Technology: AP.technology,
            FeeExpenses: AP.fee_expenses,
            RiskAndAssumptions: AP.risk_and_assumptions,
            Notes: AP.notes,
            DealOwner: AP.deal_owner,

            TotalTravelExpenses: AP.total_travel_expenses,
            DrStatus: AP.dr_status,
            CreatedBy: AP.created_by,
            CreatedAt: AP.created_at,
            LastUpdateBy: AP.last_update_by,
            UpdatedAt: AP.updated_at,
            ParentDealReview_id: AP.parent_deal_review_id,
            DrEffectiveTs: AP.dr_effective_ts,
            DrEndTs: AP.dr_end_ts,
            SolutionsArchOverview: AP.solutions_arch_overview,
            CapabilitiesLeadOverview: AP.capabilities_lead_overview,
            LegalOverview: AP.legal_overview,
            StaffingOverview: AP.staffing_overview,
            ActualStartDate: AP.actual_start_date
              ? new Date(AP.actual_start_date).toISOString().split("T")[0]
              : null,
            ActualEndDate: AP.est_close_date
              ? new Date(AP.actual_end_date).toISOString().split("T")[0]
              : null,
            TotalFixedPrice: AP.total_fixed_price,
            TotalDiscount: AP.total_discount,
            DiscountInvestment: Number(AP.wavicle_discount) < 50 ? "%" : "$",
            TotalClCost: AP.total_cl_cost,
            TotalPlCost: AP.total_pl_cost,
            ClientManaged: AP.clientmanaged,
			BackgroundCheck: AP.background_check,
            CurrentMargin: AP.current_margin,
            ExpectedMargin: AP.expected_margin,
            ExpensePercentage: AP.travel_percentage,
            PLUtilization: AP.prac_lead_utilization,
            CLUtilization: AP.comp_lead_utilization,
            MonthlyPayment: AP.monthly_payment || 0,
            InABoxEM: AP["2-in-a-box-em"],
            InABoxDL: AP["2-in-a-box-dl"],
            WavicleDiscount: AP.wavicle_discount,
            RevBefDeductions: AP.revenue_before_deductions,
            RevAftDeductions: AP.revenue_after_deductions,
            FinalGrossMargin: AP.final_gross_revenue,
            TotalWavicleCost: AP.total_wavicle_cost,
            TotalClientPrice: AP.total_client_price,
            TotalActRevenue: AP.total_revenue,
            TotalRevenueAfterDeductions: AP.total_revenue_after_deductions,
            TotalFixedPriceRevenue: AP.total_revenue,
            TotalHoursProposed: AP.total_hours_proposed,
			MarginPercentage: AP.margin_percentage,

            Expenes: AP.total_deal_expenses,
            Airfare: AP.airfare,
            Hotels: AP.hotel_stay_cost,
            GroundTransport: AP.ground_transport,
            Meals: AP.meal_expense,
            Others: AP.other_expense,
			Miscellaneous : AP.miscellaneous,
						DealRevenueAndGMBeforeDeductionsPercentage: null,
						DealRevenueAndGMAfterDeductionsPercentage: null,
						FinalGrossMarginPercentage: null,
						StaffingRatiosAndMarginOnshorePercentage: null,
						StaffingRatiosAndMarginOffshorePercentage: null,
						EM2InABoxUtilizationPercentage: null,
						DL2InABoxUtilizationPercentage: null,
			RateCardId : AP?.rate_card_id			
					},
				};
			}
		},
		//calculate Total Wavicle Investment
		caculateTotalWavicleInvestmentCost: (state, action) => {
			if (!state.RoleCardDetails?.length > 0)
				return {
					...state,
					commonInputs: { ...state.commonInputs, TotalWavicleDiscountCost: 0 },
				};
			const TotalWavicleDiscountCost = state.RoleCardDetails?.reduce(
				(total, value) => total + value.WavicleDiscountCost,
				0
			);
			return {
				...state,
				commonInputs: {
					...state.commonInputs,
					TotalDiscount: TotalWavicleDiscountCost,
				},
			};
		},
		caculateTotalPLCost: (state, action) => {
			if (!state.RoleCardDetails?.length > 0)
				return {
					...state,
					commonInputs: { ...state.commonInputs, TotalPlCost: 0 },
				};
			const TotalPlCost = state.RoleCardDetails?.reduce(
				(total, value) => total + value.PLCost,
				0
			);
			return {
				...state,
				commonInputs: {
					...state.commonInputs,
					TotalPlCost: TotalPlCost,
				},
			};
		},
		caculateTotalCLCost: (state, action) => {
			if (!state.RoleCardDetails?.length > 0)
				return {
					...state,
					commonInputs: { ...state.commonInputs, TotalClCost: 0 },
				};
			const TotalClCost = state.RoleCardDetails?.reduce(
				(total, value) => total + value.CLCost,
				0
			);
			return {
				...state,
				commonInputs: {
					...state.commonInputs,
					TotalClCost: TotalClCost,
				},
			};
		},
	},
});

export const {
	ChangeIsRequiredColumnFilledState,
	commonInputOnChange,
	addRoleCard,
	deleteRoleCard,
	updateRoleCard,
	openModal,
	closeModal,
	updateRoleCardProperty,
	setChangeData,
	setSavedData,
	addCommonInputValuesFromDatabase,
	setSaveButtonLoadingFalse,
	setSaveButtonLoadingTrue,
	ShowSnackbar,
	HideSnackbar,
	OnChangeNewDRSrceenData,
	updateStaffingIntakeProperty,
	visibleSnackBar,
	caculateTotalWavicleInvestmentCost,
	caculateTotalPLCost,
	caculateTotalCLCost,
	setCommonInputs,
} = Deals.actions;

export default Deals.reducer;
